import React, { Component } from 'react';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';


class ErrorText extends Component {
    render() {
        const { dialogContentText} = this.props
        return (
            <div id="failNote" className="note">
                <ReportProblemIcon className="infoIcon"/><span className="text">{ dialogContentText }</span>
            </div>
        )
    }
}
export default (ErrorText)